import { apiGetRequest } from '../../../../../lib/api/api';
import { TMatch } from '../../../../../lib/DBModels';
import { isWincore } from '@/features/betApprovals/pages/BetApprovals/tabs/Approvals';
import { getPrefixPath } from '@/common/utils';

export const getMatchesOfSameCompetitionTournament = async (
  matchId: string
): Promise<TMatch[]> =>
  apiGetRequest<TMatch[]>(
    `/${getPrefixPath(
      isWincore
    )}/trade-manager/sport-details/matches-of-same-competition-tournament?match_id=${matchId}`
  );
